import React from "react";
import TixxtModuleSwitcher from "components/layout/TixxtModuleSwitcher";
import {
  ContextNavigation,
  UserbarLink,
  UserbarSection,
} from "components/layout/Userbar";
import { isEmpty, map } from "lodash";
import { useQuery } from "react-query";
import InfoUserbar from "components/info/Userbar";

export default function AppCreatorUserbar() {
  const { data: pages, isLoading: pagesLoading } = useQuery<
    { slug: string; name: string }[]
  >("/pages?filter=show_in_userbar");

  const { data: apps, isLoading: appsLoading } = useQuery<
    { slug: string; name: string }[]
  >("/apps?filter=show_in_userbar");

  if (!Preload.current_member) {
    return <InfoUserbar />;
  }

  return (
    <>
      {!window.isApp && <TixxtModuleSwitcher activeModule={"info"} />}
      <ContextNavigation>
        {!isEmpty(apps) && (
          <UserbarSection title={I18n.t("js.app_creator.module_name")}>
            {map(apps, (app) => (
              <UserbarLink key={app.slug} to={`/apps/${app.slug}/items`}>
                {app.name}
              </UserbarLink>
            ))}
          </UserbarSection>
        )}
        {!isEmpty(pages) && (
          <UserbarSection title={I18n.t("js.pages.module_name")}>
            {map(pages, (page) => (
              <UserbarLink key={page.slug} to={`/pages/${page.slug}`}>
                {page.name}
              </UserbarLink>
            ))}
          </UserbarSection>
        )}
        {!pagesLoading && !appsLoading && isEmpty(pages) && isEmpty(apps) && (
          <UserbarSection>
            <div className="text-center userbar-link">
              <div className="opacity-60 userbar-link-hint">
                {I18n.t("js.app_creator.no_items_in_userbar")}
              </div>
            </div>
          </UserbarSection>
        )}
      </ContextNavigation>
    </>
  );
}
